import { GetScreenshotUrlRequest, GetScreenshotUrlResponse } from '@eigtech/meetings-types'
import { contextualGet, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

const getScreenshotUrl = ({ dateAdded, entityId, startTime }: GetScreenshotUrlRequest) =>
  contextualGet<GetScreenshotUrlResponse>(
    `${meetingsBasePath}/meeting/screenshot/${entityId}/${startTime}/${dateAdded}`
  )

export const getScreenshotUrlQueryOptions = (request: GetScreenshotUrlRequest) =>
  queryOptions({
    queryKey: meetingsQueryKeys.screenshot(request),
    queryFn: () => getScreenshotUrl(request),
  })

export const useGetScreenshotUrl = (request: GetScreenshotUrlRequest) =>
  useQuery(getScreenshotUrlQueryOptions(request))
